export default __webpack_public_path__ + "static/media/65_mobile.fd74bd93.jpg";